exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cadreCorporate {\n  background-color: white;\n  border: 1px solid grey;\n  cursor: pointer;\n  padding: 20px;\n  width: 100%;\n}\n.cadreCorporate:hover {\n  border: 2px solid rgb(18, 188, 241);\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72849ed4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/creationPages/VerificationsCreateTemplate.vue
// module id = 1619
// module chunks = 2